<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			:server-items-length="totalItens"
			item-key="id"
			:options="paginacaoInterna"
			no-data-text="Não há atas cadastradas"
			hide-default-footer
			class="arp-listview row-pointer"
			@update:options="tratarEventoAtualizarPaginacaoInterna($event)"
		>
			<template #item.numero="{ item }">
				<div class="d-flex">
					<div style="width: 25px" v-if="item.isAtaProrrogadaLegado || item.isAtaProrrogada">
						<icone-ata-prorrogada :fim-validade="item.fimValidade"></icone-ata-prorrogada>
					</div>
					<texto-tooltip
						class="ml-1"
						:texto="item.numero | numeroAtaFilter(isNumeroAtaManual)"
						:tamanho-maximo="30"
					></texto-tooltip>
				</div>
			</template>
			<template #item.descricao="{ item }">
				<texto-tooltip :texto="item.descricao" :tamanho-maximo="40"></texto-tooltip>
			</template>
			<template #item.inicioValidade="{ item }">
				<span> {{ item.inicioValidade | formatDataFilter }} </span>
			</template>
			<template #item.fimValidade="{ item }">
				<span> {{ item.fimValidade | formatDataFilter }} </span>
			</template>
			<template #item.orgao="{ item }">
				<span> {{ item.orgaoGerenciador }}</span>
			</template>
			<template #item.modalidade="{ item }">
				<span>
					{{ item.nomeModalidade | semModalidadeFilter }}
				</span>
			</template>
			<template #item.acoes="{ item }">
				<ata-listagem-botoes-acoes
					:ata="item"
					@abrir-modal-orgaos-participantes="abrirFecharModalOrgaosParticipantes"
				></ata-listagem-botoes-acoes>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>

		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>

		<modal-orgaos-participantes
			v-if="exibirModalOrgaosParticipantes"
			:exibir="exibirModalOrgaosParticipantes"
			:id-ata="idAtaModalOrgaosParticipantes"
			@fechar-modal="abrirFecharModalOrgaosParticipantes"
		></modal-orgaos-participantes>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import AtaListagemBotoesAcoes from '@/views/pages/ata/pesquisa/listagem/botoes-acoes/AtaListagemBotoesAcoes.vue'
import IconeAtaProrrogada from '@/views/components/icones/IconeAtaProrrogacao.vue'
import ModalOrgaosParticipantes from '@/views/pages/ata/pesquisa/listagem/modal-orgaos-participantes/ModalOrgaosParticipantes.vue'

export default {
	name: 'atas-listagem',
	components: { IconeAtaProrrogada, AtaListagemBotoesAcoes, ModalOrgaosParticipantes },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Nº Ata', 'numero', '17%', 'start', true),
				new TabelaColunaUtils('Descrição', 'descricao', '28%'),
				new TabelaColunaUtils('Gerenciador', 'orgao', '12%'),
				new TabelaColunaUtils('Modalidade', 'modalidade', '18%'),
				new TabelaColunaUtils('Início Vigência', 'inicioValidade', '13%', 'start', true),
				new TabelaColunaUtils('Fim Vigência', 'fimValidade', '13%', 'start', true),
				new TabelaColunaUtils('Ações', 'acoes', '10%'),
			],
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontradas atas',
			},
			idAtaModalOrgaosParticipantes: null,
			exibirModalOrgaosParticipantes: false,
		}
	},
	computed: {
		isNumeroAtaManual() {
			return this.$store.state.parametrosSistema.numeroDaAtaIsManual
		},
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
		abrirFecharModalOrgaosParticipantes(idAta) {
			this.idAtaModalOrgaosParticipantes = Number(idAta)
			this.exibirModalOrgaosParticipantes = !this.exibirModalOrgaosParticipantes
		},
	},
}
</script>

<style scoped lang="stylus">
.pr-tabela-todos-atas td:hover
	cursor pointer !important

@media (max-width: 720px)
	.pr-tabela-todos-atas
		td:nth-of-type(1):before
			content "Nº Ata:"

		td:nth-of-type(2):before
			content "Processo:"

		td:nth-of-type(3):before
			content "Descrição:"

		td:nth-of-type(4):before
			content "Órgão Gerenciador:"

		td:nth-of-type(5):before
			content "Situação:"

		td:nth-of-type(6):before
			content "Fim Validade:"

		td:nth-of-type(7):before
			display none
</style>
